/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSpotAuditSpotMediaTranscriptionQueryResponse, AuditSpotAuditSpotMediaTranscriptionPathParams } from "../models/AuditSpotAuditSpotMediaTranscription";

export function getAuditSpotAuditSpotMediaTranscriptionUrl(mediaId: AuditSpotAuditSpotMediaTranscriptionPathParams["mediaId"]) {
  const res = { method: 'GET', url: `/audit-spot/v1/media/${mediaId}/transcription` as const }
  return res
}

/**
 * @description Returns the transcription for uploaded spot media
 * @summary Get media transcription
 * {@link /audit-spot/v1/media/:mediaId/transcription}
 */
export async function auditSpotAuditSpotMediaTranscription(mediaId: AuditSpotAuditSpotMediaTranscriptionPathParams["mediaId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditSpotAuditSpotMediaTranscriptionQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditSpotAuditSpotMediaTranscriptionUrl(mediaId).url.toString(), ... requestConfig })
  return res.data
}